import * as React from "react";
const SvgIcChevronLeft = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="m13.092 6.417-3.824 3.825 3.824 3.825-1.183 1.175-5-5 5-5 1.183 1.175Z" /></svg>;
export default SvgIcChevronLeft;